import React, { Component } from "react";
import { NormalButton, NormalSelect } from "component/common";
import { InputSearch, TableWrapper } from "component/common";
import {
  NormalInput,
  NormalDateTime,
  NormalDate,
  NormalMultiSelect,
  NormalModal,
} from "component/common";
import closeIcon from "assets/images/close.png";
import "./style.scss";
import { dateFormat } from "service/helperFunctions";
import { history } from "helpers";
import { connect, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { bindActionCreators } from "redux";
import { getCommonApi, commonCreateApi } from "redux/actions/common";
import EinvoiceConsolidated from "assets/images/consolidatedeinvoice.png";
import { Toast } from "service/toast";
import {
  transactionAction,
  transactionPageNumber,
  transactionSettingListAct,
} from "redux/actions/transactionHistory";
export class TransactionHistoryClass extends Component {
  state = {
    headerDetails: [
      //{ label: "Cust Code" },
      { label: "" },
      { label: "Site" },
      { label: "Cust Name" },
      { label: "Paid On" },
      {
        label: "Modified Date",
        className: "d-none",
        divClass: "justify-content-end text-right",
      },
      {
        label: "Invoice Amount",
        divClass: "justify-content-end text-right",
        width: "125px",
      },
      {
        label: "Staff Amount",
        divClass: "justify-content-end text-right",
        width: "120px",
      },
      {
        label: "Total Amount",
        className: "d-none",
        divClass: "justify-content-end text-right",
      },
      {
        label: "Paid Amount",
        className: "d-none",
        divClass: "justify-content-end text-right",
      },
      { label: "Item", width: "300px", className: "d-none" },
      { label: "Transaction No" },
      { label: "Reference No" },
      { label: "Billed By" },
      {
        label: "No of Qty",
        className: "d-none",
        divClass: "justify-content-end text-right",
      },
      {
        label: "No of Lines",
        className: "d-none",
        divClass: "justify-content-end text-right",
      },
      {
        label: "OR",
        className: "d-none",
        divClass: "justify-content-end text-right",
      },
      { label: "Status" },
      { label: "Type" },
      { label: "Payment Remark" },
      //{ label: "" },
    ],
    einvoiceHeaderDetails: [
      { label: "Invoice Date" },
      { label: "Transaction Number" },
      { label: "Customer Name" },
      { label: "Invoice Amt" },
      { label: "Tax" },
    ],
    billingList: [],
    pageMeta: {
      chunk: 10,
      page: 1,
      total: 10,
      totalPages: 2,
    },
    formField: {
      fromDate: new Date(),
      toDate: new Date(),
      transCode: "",
      salesStaff: [],
      custName: "",
      transtype: "",
    },
    active: false,
    currentIndex: -1,
    page: 1,
    limit: 10,
    isOpenvoidCheckout: false,
    transtypeOptions: [
      { label: "All", value: "All" },
      { label: "Sales", value: "Sales" },
      { label: "Void", value: "Void" },
      { label: "TD", value: "TD" },
      { label: "Non-Sales", value: "NonSales" },
    ],
    settingData: {},
    TotalTransactionAmount: 0,
    TotalSalesAmount: 0,
    salesdefaultStaff: [],
    disbledstaffid: "",
    openEinvoicePopup: false,
    einvoiceFromDate: new Date(),
    einvoiceToDate: new Date(),
    einvoiceDetails: [],
    einvoiceTotalAmount: 0,
    isLoading: false,
    transactionOrignalList: [
      {
        id: 1,
        name: "Logo",
        checked: true,
        type: "headerList",
      },
      {
        id: 2,
        name: "Company Name",
        checked: true,
        type: "headerList",
      },
      {
        id: 3,
        name: "Company Address",
        checked: true,
        type: "headerList",
      },

      {
        id: 4,
        name: "Invoice Name",
        checked: true,
        type: "headerList",
      },
      {
        id: 5,
        name: "Remarks",
        checked: true,
        type: "footerList",
      },
      {
        id: 6,
        name: "Signature",
        checked: true,
        type: "footerList",
      },
      {
        id: 7,
        name: "Code",
        checked: true,
        type: "bodyList",
      },
      {
        id: 8,
        name: "Name",
        checked: true,
        type: "bodyList",
      },
      {
        id: 9,
        name: "NRIC",
        checked: true,
        type: "bodyList",
      },

      {
        id: 10,
        name: "Cust Refer",
        checked: true,
        type: "bodyList",
      },
      {
        id: 11,
        name: "Cust Phone",
        checked: true,
        type: "bodyList",
      },
      {
        id: 12,
        name: "Trans",
        checked: true,
        type: "bodyList",
      },
      {
        id: 13,
        name: "Date",
        checked: true,
        type: "bodyList",
      },
      {
        id: 14,
        name: "Time",
        checked: true,
        type: "bodyList",
      },
      {
        id: 15,
        name: "Issued",
        checked: true,
        type: "bodyList",
      },
      {
        id: 16,
        name: "Table Sno",
        checked: true,
        type: "bodyList",
      },
      {
        id: 17,
        name: "Table Desc",
        checked: true,
        type: "bodyList",
      },
      {
        id: 18,
        name: "Table Qty",
        checked: true,
        type: "bodyList",
      },
      {
        id: 19,
        name: "Table U/P",
        checked: true,
        type: "bodyList",
      },
      {
        id: 20,
        name: "Disc",
        checked: true,
        type: "bodyList",
      },
      {
        id: 21,
        name: "N/P",
        checked: true,
        type: "bodyList",
      },
      {
        id: 22,
        name: "Paid",
        checked: true,
        type: "bodyList",
      },
      {
        id: 23,
        name: "Balance",
        checked: true,
        type: "bodyList",
      },
      {
        id: 24,
        name: "Sold By",
        checked: true,
        type: "bodyList",
      },
      {
        id: 25,
        name: "Service By",
        checked: true,
        type: "bodyList",
      },

      {
        id: 26,
        name: "Sub Total",
        checked: true,
        type: "bodyList",
      },

      {
        id: 27,
        name: "GST",
        checked: true,
        type: "bodyList",
      },

      {
        id: 28,
        name: "Rounding",
        checked: true,
        type: "bodyList",
      },
      {
        id: 29,
        name: "Grand Total",
        checked: true,
        type: "bodyList",
      },
      {
        id: 30,
        name: "Grand Total",
        checked: true,
        type: "bodyList",
      },
      {
        id: 31,
        name: "Outstanding",
        checked: true,
        type: "bodyList",
      },
    ],
  };

  componentDidMount() {
    this.getInvoiceSettingList();

    // alert("called api first time");
    // let From = new Date();
    // let { formField } = this.state;
    // let firstdayMonth = new Date(From.getFullYear(), From.getMonth(), 1);
    // formField["fromDate"] = firstdayMonth;
    // this.setState({
    //   formField,
    // });
    if (this.props.tokenDetails.transactionviewall) {
      let { formField } = this.state;
      formField["transtype"] = "All";
      this.setState({
        formField,
      });
    }
    if (this.props.transactionFormData) {
      this.setState(
        {
          formField: this.props.transactionFormData,
        },
        () => this.getTransactions()
      );
    }
    if (!this.props.transactionFormData) {
      this.getdefaultStaffList();
    }
    // this.getdefaultStaffList();
    //this.handleItemSettings();
  }

  // getInvoiceSettingList
  getInvoiceSettingList = () => {
    this.props.getCommonApi(`invoicetemplateconfig/`).then(async (res) => {
      let { data, status } = res;
      if (status == 200) {
        if (data && data.length > 0) {
          let filterOriginalList = data;
          const modifiedList = filterOriginalList.reduce(
            (result, item) => {
              result[item.type].push(item);
              return result;
            },
            { headerList: [], footerList: [], bodyList: [] }
          );
          let filterList = [];
          filterList.push(modifiedList);
          this.props.transactionSettingListAct(filterList);
        }
      }
    });
  };

  getdefaultStaffList = async () => {
    try {
      let { salesdefaultStaff, formField } = this.state;

      this.props
        .getCommonApi(
          `empcartlist/?sales_staff=1&page=1&limit=1000&check=TransacHistory`
        )
        .then(async (res) => {
          salesdefaultStaff = [];
          let { data, status } = res;
          if (status == 200) {
            if (data.dataList) {
              if (Number(this.props.tokenDetails.role_code) == 1) {
                if (this.props.tokenDetails.transactionviewall) {
                  formField["salesStaff"].push({
                    value: "0",
                    label: "All",
                  });
                  await this.setState({
                    formField,
                  });
                }
              } else {
                for (let key of data.dataList) {
                  salesdefaultStaff.push({
                    value: key.id,
                    label: key.emp_name,
                  });

                  if (
                    key.id == Number(this.props.tokenDetails.default_loginid) &&
                    Number(this.props.tokenDetails.role_code) != 1
                  ) {
                    formField["salesStaff"].push({
                      value: key.id,
                      label: key.emp_name,
                    });

                    await this.setState({
                      disbledstaffid: key.id,
                      formField,
                    });
                  }
                }
              }

              await this.setState({ salesdefaultStaff });
              this.getTransactions();
            } else {
              this.getTransactions();
            }
          } else {
            this.getTransactions();
          }
        });
    } catch (e) {
      console.log(e);
    }
  };

  // handleItemSettings = () => {
  //   let { settingData } = this.state;
  //   this.props.getCommonApi(`userlist/`).then(key => {
  //     let { status, data } = key;
  //     console.log(key, "settingsData changeprice");
  //     if (status === 200) {
  //       settingData = data;
  //       this.setState({ settingData });
  //     }
  //   });
  // };

  getTransactions = (dStaffid) => {
    let {
      billingList,
      pageMeta,
      formField,
      page,
      limit,
      TotalTransactionAmount,
      TotalSalesAmount,
      disbledstaffid,
    } = this.state;
    let { fromDate, toDate, transCode, salesStaff, custName, transtype } =
      formField;

    this.props.transactionAction(formField);
    let selectedStaff = "";
    if (dStaffid) {
      selectedStaff = dStaffid;
    } else {
      selectedStaff = this.state.formField["salesStaff"]
        .map((e) => e.value)
        .reduce((a, e) => (a === "" ? e : a + "," + e), "");
    }
    this.setState({ TotalTransactionAmount: 0, TotalSalesAmount: 0 });
    let From = new Date();
    if (fromDate && fromDate !== "") {
      From = fromDate;
    } else {
      this.setState({ fromDate: From });
    }
    let To = new Date();
    if (toDate && toDate !== "") {
      To = toDate;
    } else {
      this.setState({ toDate: To });
    }
    this.props
      .getCommonApi(
        `transactionhistory/?from_date=${dateFormat(
          From,
          "yyyy-mm-dd"
        )}&to_date=${dateFormat(
          To,
          "yyyy-mm-dd"
        )}&transac_no=${transCode}&sales_staffs=${selectedStaff}&cust_name=${custName}&page=${
          this.props.transactionPageNum ? this.props.transactionPageNum : page
        }&limit=${limit}&invoice_type=${transtype}`
      )
      .then(async (res) => {
        console.log(res, "transactionlistdsfdfaafg");
        await this.setState({ billingList: [] });
        billingList = res.data.dataList;
        pageMeta = res.data.meta.pagination;
        TotalTransactionAmount = 0;
        TotalSalesAmount = 0;
        for (let line of res.data.dataList) {
          TotalTransactionAmount += Number(line.sa_totamt);
          TotalSalesAmount += Number(line.sales_amt);
        }
        this.setState({
          billingList,
          pageMeta,
          TotalTransactionAmount,
          TotalSalesAmount,
        });
      });
  };
  handlePrint = (id) => {
    let { billingList, pageMeta, formField, page, limit } = this.state;
    let { fromDate, toDate, transCode, salesStaff, custName } = formField;
    this.props.getCommonApi(`receiptpdf/?sa_transacno=${id}`).then((res) => {});
  };

  handlePagination = async (pageNo) => {
    let { page } = this.state;
    page = pageNo.page;
    if (!this.props.transactionPageNum) {
      await this.setState({
        page,
      });
    } else {
      await this.setState({
        page: this.props.transactionPageNum,
      });
    }
    this.props.transactionPageNumber(page);
    this.getTransactions();
  };

  handleShare = (id) => {
    this.props
      .commonCreateApi(`receiptpdfsend/?sa_transacno=${id}`)
      .then((res) => {});
  };

  handleInvoice = (id) => {
    this.props
      .getCommonApi(`customerreceiptprint/?sa_transacno=${id}`)
      .then((res) => {});
  };

  handleClick = (key) => {
    if (!this.state.active) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({
      active: !prevState.active,
      currentIndex: key,
    }));
  };

  handleOutsideClick = (e) => {
    if (this.node != null) {
      if (this.node.contains(e.target)) {
        return;
      }
    }
    this.handleClick();
  };

  handleChange = async ({ target: { value, name } }) => {
    let { formField } = this.state;
    formField[name] = value;
    await this.setState({
      formField,
    });
  };

  handleEinvoiceDateChange = async ({ target: { value, name } }) => {
    await this.setState({
      [name]: value,
    });
    // const { einvoiceFromDate, einvoiceToDate } = this.state;
    // if (name === "einvoiceFromDate") {
    //   einvoiceFromDate = value;
    //   await this.setState({
    //     einvoiceFromDate,
    //   });
    // }
    // if (name === "einvoiceToDate") {
    //   einvoiceToDate = value;
    //   await this.setState({
    //     einvoiceToDate,
    //   });
    // }
  };

  handleDatePick = async (name, value) => {
    let { formField } = this.state;
    formField[name] = value;
    await this.setState({
      formField,
    });
    // this.props.transactionAction(formField);
    this.getTransactions();
  };

  handleSearch = () => {
    this.getTransactions();
  };

  handleMultiSelectDefaultStaff = async (data = []) => {
    let { formField, salesdefaultStaff } = this.state;

    console.log("handleToMulitSeleect" + JSON.stringify(formField));
    console.log("salesdefaultStaff" + JSON.stringify(salesdefaultStaff));

    let AllisSelected = data.filter((acc) => Number(acc.value) == 0).length;
    let result = [];
    if (AllisSelected > 0) {
      data = [];
      data.push({ value: "0", label: "All" });
      let { formField, salesdefaultStaff } = this.state;
      formField["salesStaff"] = data;

      salesdefaultStaff = data;

      await this.setState({
        salesdefaultStaff,
        formField,
      });
    } else {
      result = data;

      formField["salesStaff"] = result;
      await this.setState({
        formField,
      });
      this.props
        .getCommonApi(
          `empcartlist/?sales_staff=1&page=1&limit=1000&check=TransacHistory`
        )
        .then(async (res) => {
          console.log(res, "salesdefaultstaff");

          salesdefaultStaff = [];
          let { data, status } = res;
          if (status == 200) {
            if (data.dataList) {
              for (let key of data.dataList) {
                salesdefaultStaff.push({
                  value: key.id,
                  label: key.emp_name,
                });
              }
              await this.setState({ salesdefaultStaff });
            }
          }
        });
    }
  };
  defaultAllUpdate = async () => {};

  // handleSettingPage
  handleSettingPage = () => {
    alert("selectpage");
  };

  handleEinvoicePopup = () => {
    this.setState({
      openEinvoicePopup: true,
    });
  };

  handleEinvoiceDialog = () => {
    this.setState({
      openEinvoicePopup: false,
      einvoiceDetails: [],
    });
  };
  handleShowEinvoice = () => {
    const { einvoiceFromDate, einvoiceToDate } = this.state;
    this.setState({
      isLoading: true,
    });
    const formatDate = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const formattedFromDate = formatDate(einvoiceFromDate);
    const formattedToDate = formatDate(einvoiceToDate);
    this.props
      .getCommonApi(
        `einvoice/consolidated/?start_date=${formattedFromDate}&end_date=${formattedToDate}`
      )
      .then((res) => {
        this.setState({
          einvoiceDetails: res?.data?.invoices,
          einvoiceTotalAmount: res?.data?.summary?.total_amount,
          isLoading: false,
        });
        console.log(res, "response");
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
        });
      });
  };
  handleEinvoiceSubmit = () => {
    const { einvoiceFromDate, einvoiceToDate, einvoiceDetails } = this.state;
    this.setState({
      isLoading: true,
    });
    const formatDate = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };
    const formatSubmitDate = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    };

    const formattedFromDate = formatDate(einvoiceFromDate);
    const formattedToDate = formatDate(einvoiceToDate);
    let payload = {
      transaction_no: einvoiceDetails
        ?.filter((item) => Number(item?.amount) <= 100000)
        ?.map((item) => item?.transaction_no),
      submit_date: formatSubmitDate(new Date()),
    };
    this.props
      .commonCreateApi(
        `einvoice/consolidatedsubmit/?start_date=${formattedFromDate}&end_date=${formattedToDate}`,
        payload
      )
      .then((res) => {
        Toast({
          type: "success",
          message: "E-Invoice Submitted Successfully",
        });
        this.setState({
          isLoading: false,
          einvoiceDetails: [],
          openEinvoicePopup: false,
        });
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
        });
      });
  };
  render() {
    let {
      headerDetails,
      einvoiceHeaderDetails,
      pageMeta,
      billingList,
      formField,
      transtypeOptions,
      settingData,
      TotalTransactionAmount,
      salesdefaultStaff,
      disbledstaffid,
      openEinvoicePopup,
      einvoiceFromDate,
      einvoiceToDate,
      einvoiceDetails,
      einvoiceTotalAmount,
      isLoading,
    } = this.state;
    let { fromDate, toDate, transCode, salesStaff, custName, transtype } =
      formField;
    let { t } = this.props;
    return (
      <>
        <div className="billing-section p-3">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 my-3 d-flex">
            <p className="label-head ">{t("Transaction History")}</p>
            <NormalButton
              buttonClass="ml-3"
              mainbg={true}
              className="confirm"
              label="Setting"
              outline={false}
              onClick={() =>
                history.push(`/admin/transactionhistory/transcationSetting`)
              }
            />
            {this.props.tokenDetails.einvoice && (
              <button
                className="consolidated-einvoice-btn"
                onClick={this.handleEinvoicePopup}
                style={{ backgroundColor: "#79c253" }}
              >
                <div className="einvoice-btn__logo-container">
                  <div className="einvoice-btn__logo-shadow"></div>
                  <img
                    src={EinvoiceConsolidated}
                    alt="E-Invoice"
                    className="einvoice-btn__logo"
                  />
                </div>
                <span className="einvoice-btn__text">
                  {" "}
                  Consolidated Einvoice
                </span>
              </button>
            )}
            {this.props.tokenDetails.netsadmin && (
              <NormalButton
                buttonClass="ml-3"
                mainbg={true}
                className="confirm"
                label="NETS Admin"
                outline={false}
                onClick={() =>
                  history.push(`/admin/transactionhistory/NETSAdmin`)
                }
              />
            )}
            {this.props.tokenDetails.insuranceinvoice && (
              <div className="mx-3">
                <NormalButton
                  buttonClass="ml-3"
                  mainbg={true}
                  className="confirm"
                  label="Insurance Document"
                  outline={false}
                  onClick={() => history.push(`/admin/insurance-document`)}
                />
              </div>
            )}
          </div>
          <div className="row mt-5 filter rowGapBottom">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3">
              <div className="row mb-2">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                  <label className="text-left w-100 text-black common-label-text mr-2">
                    {t("From Date")}
                  </label>
                </div>
                <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                  <div className="input-group">
                    <NormalDateTime
                      onChange={this.handleDatePick}
                      inputcol="p-0 inTime"
                      value={fromDate ? new Date(fromDate) : new Date()}
                      name="fromDate"
                      //className="dob-pick"
                      showYearDropdown={true}
                      dateFormat="dd/MM/yyyy"
                      maxDate={new Date(toDate)}
                      showDisabledMonthNavigation
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                  <label className="text-left w-100 text-black common-label-text mr-2">
                    {t("To Date")}
                  </label>
                </div>
                <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                  <div className="input-group">
                    <NormalDateTime
                      onChange={this.handleDatePick}
                      inputcol="p-0 inTime"
                      value={toDate ? new Date(toDate) : new Date()}
                      name="toDate"
                      // className="dob-pick"
                      showYearDropdown={true}
                      dateFormat="dd/MM/yyyy"
                      minDate={new Date(fromDate)}
                      showDisabledMonthNavigation
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3">
              <div className="row mb-2">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-6">
                  <label className="text-left w-100 text-black common-label-text mr-2">
                    {t("Cust Name/ ref/ Code")}
                  </label>
                </div>
                <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-6">
                  <div className="input-group">
                    <NormalInput
                      value={custName}
                      name="custName"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                  <label className="text-left w-100 text-black common-label-text mr-2">
                    {t("Sales Staff")}
                  </label>
                </div>
                <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                  <div className="input-group">
                    {Number(this.props.tokenDetails.role_code) == 1 ? (
                      <NormalMultiSelect
                        id={`salesStaff`}
                        handleMultiSelect={this.handleMultiSelectDefaultStaff}
                        options={salesdefaultStaff}
                        value={salesStaff}
                        defaultValue={salesStaff}
                        name="salesStaff"
                        disabled={
                          Number(this.props.tokenDetails.role_code) == 1
                            ? false
                            : true
                        }
                      />
                    ) : (
                      <NormalSelect
                        options={salesdefaultStaff}
                        value={disbledstaffid}
                        name="salesStaff"
                        onChange={this.handleChange}
                        disabled={true}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3">
              <div className="row mb-2">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-5">
                  <label className="text-left w-100 text-black common-label-text mr-2">
                    {t("Transaction Code")}
                  </label>
                </div>
                <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-7">
                  <div className="input-group">
                    <NormalInput
                      value={transCode}
                      name="transCode"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-5">
                  <label className="text-left w-100 text-black common-label-text mr-2">
                    {t("Transaction Type")}
                  </label>
                </div>
                <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-7">
                  <div className="input-group">
                    <NormalSelect
                      placeholderrequired={false}
                      options={transtypeOptions}
                      value={t(transtype)}
                      iconname="icon-down-key"
                      name="transtype"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2">
              <div className="row">
                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-12">
                  <div className="mb-2">
                    <NormalButton
                      mainbg={true}
                      className="confirm"
                      label="Search"
                      outline={false}
                      onClick={this.handleSearch}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-8">
                  <label className="text-left h6 w-100 fw-500 common-label-text ">
                    {t("Total Staff Amount")}
                  </label>
                </div>

                <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-4">
                  <label className="text-right h6 w-100 fw-500 common-label-text">
                    $
                    {this.state.TotalSalesAmount
                      ? Number(this.state.TotalSalesAmount).toFixed(2)
                      : 0}
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-8">
                  <label className="text-left  fs-11 w-100 fw-500 common-label-text">
                    {t("Total Invoice Amount")}
                  </label>
                </div>
                <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-4">
                  <label className="text-right fs-11 w-100 fw-500 common-label-text">
                    $
                    {this.state.TotalTransactionAmount
                      ? Number(this.state.TotalTransactionAmount).toFixed(2)
                      : 0}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="billing-table">
            <div className="py-4">
              <div className="table-container">
                <TableWrapper
                  headerDetails={headerDetails}
                  queryHandler={this.handlePagination}
                  pageMeta={pageMeta}
                >
                  {billingList
                    ? billingList.map((dataitem, index) => {
                        let {
                          icon,
                          id,
                          sa_custno,
                          sa_custname,
                          sa_date,
                          sa_totamt,
                          sa_transacno_ref,
                          void_refno,
                          sa_staffname,
                          sa_status,
                          sa_transacno_type,
                          sa_transacno,
                          payment_remarks,
                          isvoid,
                          no_of_qty,
                          no_of_lines,
                          or,
                          paid_amount,
                          total_amount,
                          item,
                          new_date,
                          sales_amt,
                          itemsite_code,
                        } = dataitem;
                        return (
                          <tr key={index}>
                            {/* {Number(this.props.tokenDetails.role_code) == 1 ||
                            Number(this.props.tokenDetails.role_code) == 2 ? (
                              <td className="position-relative">
                                <NormalButton
                                  buttonClass={"mx-0"}
                                  mainbgrev={true}
                                  className="confirm fs-11"
                                  label={t("Change Price")}
                                  outline={false}
                                  onClick={() =>
                                    history.push(
                                      `/admin/transactionhistory/pricechange/${id}`
                                    )
                                  }
                                  disabled={!isvoid ? false : true}
                                />
                              </td>
                            ) : (
                              ""
                            )} */}

                            {/*<td>
                              <div className="text-left">{sa_custno}</div>
                            </td>*/}
                            <td className="position-relative">
                              <div className="d-flex justify-content-center">
                                <NormalButton
                                  buttonClass={"mx-0"}
                                  mainbgrev={true}
                                  className="confirm fs-11"
                                  label={t("View")}
                                  outline={false}
                                  onClick={() =>
                                    history.push(
                                      `/admin/transactionhistory/print/bill/${sa_transacno}`
                                    )
                                  }
                                />
                                {(Number(this.props.tokenDetails.role_code) ==
                                  1 ||
                                  Number(this.props.tokenDetails.role_code) ==
                                    2) &&
                                this.props.tokenDetails.showChangePrice ? (
                                  <NormalButton
                                    buttonClass={"mx-0 ml-1"}
                                    mainbgrev={true}
                                    className="confirm fs-11"
                                    label={t("Change Price")}
                                    outline={false}
                                    onClick={() =>
                                      history.push(
                                        `/admin/transactionhistory/pricechange/${id}`
                                      )
                                    }
                                    disabled={!isvoid ? false : true}
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </td>
                            <td>
                              <div className="text-left">{itemsite_code}</div>
                            </td>
                            <td>
                              <div className="text-left">{sa_custname}</div>
                            </td>
                            <td>
                              <div className="text-right">{sa_date}</div>
                            </td>
                            <td className="d-none">
                              <div className="text-right">{new_date}</div>
                            </td>
                            <td>
                              <div className="text-right">{sa_totamt}</div>
                            </td>
                            <td>
                              <div className="text-right">{sales_amt}</div>
                            </td>
                            <td className="d-none">
                              <div className="text-right">{total_amount}</div>
                            </td>
                            <td className="d-none">
                              <div className="text-right">{paid_amount}</div>
                            </td>
                            <td className="d-none">
                              <div className="text-left">{item}</div>
                            </td>
                            <td>
                              <div className="text-left">
                                {sa_transacno_ref}
                              </div>
                            </td>
                            <td>
                              <div className="text-left">{void_refno}</div>
                            </td>
                            <td>
                              <div className="text-left">{sa_staffname}</div>
                            </td>
                            <td className="d-none">
                              <div className="text-right">{no_of_qty}</div>
                            </td>
                            <td className="d-none">
                              <div className="text-right">{no_of_lines}</div>
                            </td>
                            <td className="d-none">
                              <div className="text-right">{or}</div>
                            </td>

                            <td>
                              <div className="text-left">{sa_status}</div>
                            </td>
                            <td>
                              <div className="text-left">
                                {sa_transacno_type}
                              </div>
                            </td>
                            <td>
                              <div className="text-left">{payment_remarks}</div>
                            </td>
                            {/*
                            <td className="position-relative">
                              <div className="d-flex justify-content-center">
                                <NormalButton
                                  buttonClass={"mx-0"}
                                  mainbgrev={true}
                                  className="confirm fs-11"
                                  label={t("View")}
                                  outline={false}
                                  onClick={() =>
                                    history.push(
                                      `/admin/transactionhistory/print/bill/${sa_transacno}`
                                    )
                                  }
                                />
                                {(Number(this.props.tokenDetails.role_code) ==
                                  1 ||
                                  Number(this.props.tokenDetails.role_code) ==
                                    2) &&
                                settingData.showChangePrice ? (
                                  <NormalButton
                                    buttonClass={"mx-0 ml-1"}
                                    mainbgrev={true}
                                    className="confirm fs-11"
                                    label={t("Change Price")}
                                    outline={false}
                                    onClick={() =>
                                      history.push(
                                        `/admin/transactionhistory/pricechange/${id}`
                                      )
                                    }
                                    disabled={!isvoid ? false : true}
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </td>
                            */}
                          </tr>
                        );
                      })
                    : null}
                </TableWrapper>
              </div>
            </div>
          </div>
        </div>
        <NormalModal
          className={"payment-modal"}
          style={{ minWidth: "65%" }}
          modal={openEinvoicePopup}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleEinvoiceDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <>
            <div>
              <div>
                <h5>Consolidated E-Invoice </h5>
              </div>
              <div className="col-12 d-flex mb-5 mt-4 align-items-center">
                <div className="col-4">
                  <label className="text-left text-black common-label-text ">
                    From Date
                  </label>
                  <div className="input-group">
                    <NormalDate
                      value={einvoiceFromDate}
                      name="einvoiceFromDate"
                      type="date"
                      onChange={this.handleEinvoiceDateChange}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <label className="text-left text-black common-label-text ">
                    To Date
                  </label>
                  <div className="input-group">
                    <NormalDate
                      value={einvoiceToDate}
                      name="einvoiceToDate"
                      type="date"
                      onChange={this.handleEinvoiceDateChange}
                    />
                  </div>
                </div>
                <div className="col-4 mt-4 d-flex justify-content-end">
                  <NormalButton
                    onClick={this.handleShowEinvoice}
                    label="Show Invoices"
                    mainbg={true}
                    className=""
                  />
                </div>
              </div>
              <div
                className="col-12"
                style={{
                  height: `${einvoiceDetails?.length > 0 ? "60vh" : "auto"}`,
                  overflow: "scroll",
                }}
              >
                <div className="table-container">
                  <TableWrapper headerDetails={einvoiceHeaderDetails}>
                    {isLoading ? (
                      <tr>
                        <td colSpan="12">
                          <div class="d-flex mt-5 align-items-center justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : einvoiceDetails && einvoiceDetails?.length > 0 ? (
                      <>
                        {einvoiceDetails.map((item, index) => {
                          const isHighAmount = Number(item?.amount) > 100000;
                          return (
                            <tr
                              key={index}
                              style={{
                                backgroundColor: isHighAmount
                                  ? "rgb(255 65 82)"
                                  : "transparent",
                              }}
                            >
                              <td>
                                <div className="text-left">{item?.date}</div>
                              </td>
                              <td>
                                <div className="text-left">
                                  {item?.transaction_no}
                                </div>
                              </td>
                              <td>
                                <div className="text-left">
                                  {item?.customer_name}
                                </div>
                              </td>
                              <td>
                                <div className="text-left">{item?.amount}</div>
                              </td>
                              <td>
                                <div className="text-left">{item?.tax}</div>
                              </td>
                            </tr>
                          );
                        })}
                        <tr>
                          <td
                            colSpan="3"
                            className="text-center font-weight-bold"
                          >
                            Total
                          </td>
                          <td className="text-left font-weight-bold">
                            {einvoiceTotalAmount.toFixed(2)}
                          </td>
                          <td></td>
                        </tr>
                      </>
                    ) : (
                      <tr>
                        <td colSpan={12} className="text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </TableWrapper>
                </div>
              </div>
              {!isLoading && (
                <div className="col-12 mt-2 d-flex justify-content-end">
                  <div className="mx-3">
                    <NormalButton
                      onClick={this.handleEinvoiceDialog}
                      label="Cancel"
                      mainbg={true}
                      className=""
                    />
                  </div>
                  <div>
                    <NormalButton
                      onClick={this.handleEinvoiceSubmit}
                      label="Submit"
                      mainbg={true}
                      className=""
                    />
                  </div>
                </div>
              )}
            </div>
          </>
        </NormalModal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  tokenDetails: state.authStore.tokenDetails,
  transactionFormData: state.transactionStore.transactionFormData,
  transactionPageNum: state.transactionStore.transactionPageNum,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      commonCreateApi,
      transactionAction,
      transactionPageNumber,
      transactionSettingListAct,
    },
    dispatch
  );
};

export const TransactionHistory = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(TransactionHistoryClass)
);
